import { useContext } from 'react';

import { HistogramSelectionAreaRef } from '../contexts/HistogramSelectionAreaRef.context.js';

export const useHistogramSelectionAreaRef = () =>
  useContext(HistogramSelectionAreaRef);
